import { Channel, ChannelType } from '@/types/channel.types';

export function isTownhallChannel(value: Channel['type']): boolean {
  return value === ChannelType.Townhall;
}

export function isWebinarChannel(value: Channel['type']): boolean {
  return value === ChannelType.Webinar;
}
